/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const ArrowLeft = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 10 7">
      <path
        d="M9.9619,3.6914 C10.0119,3.5684 10.0119,3.4314 9.9619,3.3084 C9.9369,3.2484 9.8999,3.1924 9.8529,3.1454 L6.8539,0.1464 C6.6579,-0.0486 6.3419,-0.0486 6.1469,0.1464 C5.9509,0.3414 5.9509,0.6584 6.1469,0.8534 L8.2929,3.0004 L0.4999,3.0004 C0.2239,3.0004 -0.0001,3.2234 -0.0001,3.5004 C-0.0001,3.7764 0.2239,4.0004 0.4999,4.0004 L8.2929,4.0004 L6.1469,6.1464 C5.9509,6.3414 5.9509,6.6584 6.1469,6.8534 C6.2439,6.9514 6.3719,7.0004 6.4999,7.0004 C6.6279,7.0004 6.7559,6.9514 6.8539,6.8534 L9.8529,3.8544 C9.8999,3.8074 9.9369,3.7524 9.9619,3.6914"
        transform="matrix(-1 0 0 1 10 0)"
      />
    </BaseSvgIcon>
  )
}

export default ArrowLeft
